import styled from 'styled-components';
import { CenteredSpaceWrap, ButtonBase } from '../../Common/dweb-common.styles';

export const OuterWrapDiv = styled.section(
  props => `
  display:flex;
  flex-direction: column;
  width:100%;
  position:sticky;
  top: 0;
  z-index: 100;
  background-color: ${props.theme.colors.goBrandBlue.base};
`
);

export const RadioWrapper = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
  ${props => props.theme.justifyStart};
  color: ${props => props.theme.colors.goWhite.base};
  max-width: 120rem;
  width: 100%;
  margin: 0 auto;
  padding: ${props => props.theme.spacing.custom(12)} 0;
`;

export const ClassWrap = styled.div`
  padding-right: ${props => props.theme.spacing.large};
  ${props => props.theme.flexCol};
`;

export const RadioLabel = styled.label`
  position: relative;
  &:hover {
    cursor: pointer;
  }
`;

export const RadioButton = styled.input`
  display: none;
  &:checked + ${RadioLabel}::before {
    content: '';
    background: ${props => props.theme.colors.goWhite.base};
    box-shadow: inset 0 0 0 3px #0069e2;
  }
  & + ${RadioLabel}::before {
    content: '';
    /* background: transparent; */
    border: ${props => `2px solid ${props.theme.colors.goWhite.base}`};
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin-right: 1rem;
    text-align: center;
    margin-top: -4px;
    border-radius: 50%;
  }
`;

export const LabelText = styled.span`
  font-size: ${props => props.theme.font.custom(14)};
  /* color: #000000; */
`;

export const WrapperStyle = styled(CenteredSpaceWrap)(
  props => `
  max-width: 120rem;
  width:100%;
  margin: 0 auto;
  padding: 0 0 ${props.theme.spacing.custom(12)} 0;
  background-color: ${props.theme.colors.goBrandBlue.base};
`
);

export const SearchWrapperArea = styled.div(
  props => `
  width: 22rem;
  padding-right: ${props.theme.spacing.custom(12)};
  position: relative;
`
);

export const SwapIconWrapper = styled.div`
  width: 4rem;
  ${props => props.theme.flexCol};
  ${props => props.theme.justifyCenter};
  ${props => props.theme.alignItemsCenter};
  padding-right: ${props => props.theme.spacing.custom(12)};
`;

// export const CheckinCheckoutWrapper = styled.div(
//   props => `
//   padding-right: ${props.theme.spacing.custom(12)};
// `,
// );

export const DepartureArrivalWrapper = styled.div(
  props => `
  width: 14rem;
  padding-right: ${props.theme.spacing.custom(12)};
`
);

export const PaxWrapperStyle = styled.div(
  props => `
  width: 22rem;
  padding-right: ${props.theme.spacing.small};
  position: relative;
`
);

export const SearchLabelStyle = styled.label(
  props => `
  color: white;
  padding-bottom: ${props.theme.spacing.small};
  padding-left: ${props.theme.spacing.custom(2)};
  display:flex;
  opacity: 0.6;
  font-size: 12px;
`
);

export const SearchInputStyle = styled.input(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.dark};
  color: white;
  border: none;
  font-size: ${props.theme.font.custom(14)};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
  ${!props.hasValue ? props.theme.op06 : ''}

  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.small} ${props.theme.spacing.custom(
    12
  )} ${props.theme.spacing.base};
    line-height: 1.3;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    flex-direction: row;
    align-items: center;
    justify-conent: center;
    &::-webkit-input-placeholder{
      color: white;
      opacity: 0.5;
      ${SearchInputStyle}.font-size;
      ${SearchInputStyle}.font-family;
      ${SearchInputStyle}.font-weight;
    }
    &:focus{
      box-shadow: none;
      outline: none;
    }
`
);

export const UpdateSearchBtn = styled(ButtonBase)(
  props => `
  background-color: ${props.theme.colors.goWhite.base};
  margin-top: ${props.theme.spacing.large};
  height: 4.2rem;
  width: 19.6rem;
  color: #2276E3;
`
);

export const ErrorWrap = styled.div`
  padding: ${props => props.theme.spacing.custom(4)} 1rem;
  background-color: #f6e7e7;
  color: #80605d;
  /* margin-top:1rem; */
  border-radius: 2px;
  ${props => props.theme.alignItemsCenter};
  width: 100%;
`;

export const ErrorText = styled.span`
  font-size: ${props => props.theme.font.custom(14)};
`;

export const ErrorStatus = styled.span`
  background-color: #c96059;
  color: #fff;
  font-size: 11px;
  text-transform: uppercase;
  margin-right: 10px;
  padding: 3px 7px 1px;
  border-radius: 5px;
`;

export const FareOptionsWrapper = styled.div(
  props => `
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 1;
  background-color: rgb(34, 116, 224);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 0 ${props.theme.spacing.custom(12)} 0;
  color: #fff;
`
);
